import { render, staticRenderFns } from "./InvoiceFooter.vue?vue&type=template&id=4dcee051&scoped=true&"
import script from "./InvoiceFooter.vue?vue&type=script&lang=js&"
export * from "./InvoiceFooter.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceFooter.vue?vue&type=style&index=0&id=4dcee051&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcee051",
  null
  
)

export default component.exports